module.exports = __webpack_public_path__ + "img/cuff_width.6a864057.png";